import React from "react";
import classNames from "classnames";

import { LabelProps } from "./Label.types";
import "./Label.scss";

const Label = React.forwardRef<HTMLLabelElement, LabelProps>(
  ({ size, children, className, hidden, required, theme, ...props }, ref) => {
    const classes = classNames(
      "elemental-Label",
      {
        "elemental-Label--large": size === "large",
        "elemental-Label--small": size === "small",
        "elemental-Label--invalid": theme === "invalid",
        "elemental-Label--hidden": hidden === true,
      },
      className
    );
    return (
      <label
        className={classes}
        data-testid="label-component"
        ref={ref}
        {...props}
      >
        {children}
        {!!required && (
          <span className="elemental-Label-requiredIndicator"> *</span>
        )}
      </label>
    );
  }
);

export default Label;
